
const BAN_TEAM_1 = 1;
const BAN_TEAM_2 = 2;
const PICK_TEAM_1 = 3;
const PICK_TEAM_2 = 4;


const PHASE_PICKS = "picks";
const PHASE_BANS = "bans";

exports.ROUND_DURATION = 30 * 1000;

const PHASES = [
  BAN_TEAM_1, BAN_TEAM_2, BAN_TEAM_1, BAN_TEAM_2, BAN_TEAM_1, BAN_TEAM_2,
  PICK_TEAM_1, PICK_TEAM_2, PICK_TEAM_2, PICK_TEAM_1, PICK_TEAM_1, PICK_TEAM_2,
  BAN_TEAM_2, BAN_TEAM_1, BAN_TEAM_2, BAN_TEAM_1,
  PICK_TEAM_2, PICK_TEAM_1, PICK_TEAM_1, PICK_TEAM_2
];

exports.getTeamTurn = phase => {
  if (phase >= PHASES.length) {
    return;
  }
  return PHASES[phase] % 2 === 0 ? 1 : 0;
};

 exports.getPhase = phase => {
   if (phase >= PHASES.length) {
     return;
   }

   return PHASES[phase] <= 2 ? PHASE_BANS : PHASE_PICKS;
 }

 exports.getSelectedChampion = (round, teams) => {
   const phase = exports.getPhase(round);
   return typeof(phase) === "string" ? teams[exports.getTeamTurn(round)][phase][exports.PHASE_GROUP_INDEX[round]] : null;
 };

exports.PHASE_GROUP_INDEX = PHASES.reduce((indicies, phase) => {
  indicies.list.push(indicies[phase]++);
  return indicies;
}, {1: 0, 2: 0, 3:0, 4:0, list: []}).list;

exports.PHASE_PICKS = PHASE_PICKS;
exports.PHASE_BANS = PHASE_BANS;

exports.BAN_TEAM_1 = BAN_TEAM_1;
exports.BAN_TEAM_2 = BAN_TEAM_2;
exports.PICK_TEAM_1 = PICK_TEAM_1;
exports.PICK_TEAM_2 = PICK_TEAM_2;

exports.PHASES = PHASES;



// WEBPACK FOOTER //
// ./src/phases.js